/**
 * The closed set of legacy `MetaspaceEvent['type']` values (Center-PWA
 * `reducers/metaspaceEventsReducer.ts`) a `SpaceWire.legacyEventType` may bridge into.
 *
 * It lives in space-format, not in the renderer, because it is a FORMAT constraint:
 * `validateSpaceDocument` rejects a document declaring a name outside this set, so an unbridgeable
 * wire is caught at authoring time rather than silently dropped at render. The renderer re-exports
 * this list rather than keeping its own copy — two copies is how the runtime guard and the
 * validator drift apart, which is what let "rejected at validation" become a false claim.
 *
 * Keep in sync with `metaspaceEventsReducer.ts`'s `MetaspaceEvent['type']` union.
 */
export const LEGACY_BRIDGE_EVENT_TYPES = [
  'CHAT_TRIGGERED',
  'TOOLBAR_EXPAND',
  'THREAD_CONTEXT_LOAD',
  'SPHERE_CREATED',
  'SPHERE_UPDATED',
  'SPHERE_STATUS_CHANGED',
  'OPEN_SPHERE_EDITOR',
  'TASK_FILTER_TRIGGERED',
  'SPHERE_CENTERED',
  'TIMELINE_TRIGGERED',
  'CONVERSATION_MESSAGE_CLICKED',
] as const;

export type LegacyBridgeEventType = (typeof LEGACY_BRIDGE_EVENT_TYPES)[number];

export function isLegacyBridgeEventType(value: unknown): value is LegacyBridgeEventType {
  return typeof value === 'string' && (LEGACY_BRIDGE_EVENT_TYPES as readonly string[]).includes(value);
}
